import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Medal, Users } from "lucide-react";

const resetsIn = (iso) => {
  const ms = new Date(iso) - Date.now();
  if (!(ms > 0)) return "any moment";
  const d = Math.floor(ms / 86400000);
  return d > 0 ? `${d}d` : `${Math.floor(ms / 3600000)}h`;
};

// Monthly referral leaderboard — top recruiter wins a wallet credit. compact=true for the share modal.
export function ReferralBoard({ compact = false }) {
  const [b, setB] = useState(null);
  useEffect(() => { api.get("/referrals/leaderboard").then(({ data }) => setB(data)).catch(() => {}); }, []);
  if (!b) return null;
  return (
    <div data-testid="referral-board" className={`rounded-2xl border border-gold/30 bg-gold/5 ${compact ? "p-4" : "p-5"}`}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-gold"><Medal size={14} /> Top recruiters this month</p>
        <p data-testid="referral-resets" className="text-[11px] text-text-muted">Resets in {resetsIn(b.resets_at)} · prize: {b.prize}</p>
      </div>
      <div className={`mt-3 ${compact ? "space-y-1.5" : "space-y-2.5"}`}>
        {b.top.length === 0 && <p data-testid="referral-empty" className="text-sm text-text-muted">No verified sign-ups yet this month — share your link to take the lead.</p>}
        {b.top.slice(0, compact ? 3 : 5).map((t, i) => (
          <div key={t.user_id} data-testid={`referral-rank-${i + 1}`} className="flex items-center gap-3">
            <span className={`w-6 h-6 rounded-full border flex items-center justify-center text-[11px] ${i === 0 ? "border-gold text-gold" : "border-white/20 text-text-muted"}`}>{i + 1}</span>
            {t.photo_url && <img src={t.photo_url} alt="" className="w-7 h-7 rounded-full object-cover border border-white/10" />}
            <span className="text-sm flex-1 truncate">{t.name}{t.handle && <span className="text-text-muted text-xs font-mono ml-2">{t.handle}@velluto</span>}</span>
            <span className="text-sm text-gold flex items-center gap-1"><Users size={12} /> {t.verified_signups}</span>
          </div>
        ))}
      </div>
      <p data-testid="referral-mine" className="mt-3 text-xs text-text-muted">
        You: <span className="text-text-main">{b.mine.verified_signups}</span> verified sign-up{b.mine.verified_signups === 1 ? "" : "s"}{b.mine.rank ? ` · rank #${b.mine.rank}` : ""}
        {b.last_month_winner && <> · Last month's winner: <span className="text-gold">{b.last_month_winner.name}</span> ({b.last_month_winner.verified_signups})</>}
      </p>
    </div>
  );
}
